import axios from "axios";

export const checkRedisHealth = async (
  canvasId: string,
  supabaseClient: any
): Promise<{
  confirmedRedisDown: boolean;
  anyCheckFailed: boolean;
}> => {
  if (!supabaseClient) {
    return {
      confirmedRedisDown: false,
      anyCheckFailed: false,
    };
  }

  const checkRedisIsUp = async (
    canvasId: string,
    supabaseClient: any
  ): Promise<boolean> => {
    try {
      const redisHealthUrl = `${
        import.meta.env.VITE_BACKEND_BASE_URL
      }/redis-health`;
      const res = await axios.get(redisHealthUrl, {});
      return res.status === 200;
    } catch (e) {
      console.error("Error checking Redis health:", e);
      return false;
    }
  };

  let redisIsUp = await checkRedisIsUp(canvasId, supabaseClient);
  let attempts = 1;

  let anyCheckFailed = !redisIsUp;

  // Check 3 times until it's up with a 1 second delay between each check
  while (attempts < 3 && !redisIsUp) {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    redisIsUp = await checkRedisIsUp(canvasId, supabaseClient);

    anyCheckFailed = anyCheckFailed || !redisIsUp;
    attempts++;
  }

  return {
    confirmedRedisDown: !redisIsUp,
    anyCheckFailed,
  };
};
